<template>
  <div>
    <v-menu offset-x>
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on" :class="{'green--text':url}" :disabled="readOnly && !url"><v-icon>mdi-paperclip</v-icon></v-btn>
      </template>
      <v-list dense>
        <template>
          <template v-if="url">
            <v-list-item @click="open()"><v-list-item-title>View attachment</v-list-item-title></v-list-item>
            <v-divider v-if="!readOnly"/>
          </template>
          <template v-if="!readOnly">
            <v-list-item @click="$refs.fileInput.click()"><v-list-item-title>{{url?'Replace':'Add'}} attachment</v-list-item-title></v-list-item>
            <v-list-item v-if="url" @click="clear"><v-list-item-title>Delete attachment</v-list-item-title></v-list-item>
          </template>
        </template>
      </v-list>
    </v-menu>
    <input type="file" style="display:none" ref="fileInput" @change="newAttachment">
    <v-snackbar :timeout="10000" v-model="error" color="error" top>
      {{uploadError}}
      <v-btn plain @click="error=false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>

export default {
  name: 'Attachment',
	props: {
    value: {type:String,required:false},
    maxMB: {type:Number,required:false,default:1},
    readOnly: {type:Boolean,required:false,defualt:false}
  },
  data() {
    return {
      files: [],
      url: null,
      error: false,
      uploadError: '',
    }
  },
  watch: {
    value() {
      this.url = this.value;
    }
  },
  methods: {
    open() {
      if (this.url.substring(0, 5) !== 'data:') {
        const win = window.open(this.url);
        if (!win) {
          this.$store.commit('setError', {type:'warning',message:`Your browser permissions must allow pop-up windows`});
          return;
        }
      }
      else {
        const win = window.open();
        if (!win) {
          this.$store.commit('setError', {type:'warning',message:`Your browser permissions must allow pop-up windows`});
          return;
        }
        const document = win.document;
        const obj = document.createElement('object');
        obj.style.width="100%";
        obj.style.height="100%";
        obj.data = this.url;
        document.body.appendChild(obj);
        win.document.close();
        win.focus();
      }
    },
    newAttachment(event) {
      const file = event.target.files[0]
      this.uploadError = '';
      if (file == null)
        return;
      const maxSize = this.maxMB * 1024*1024;
			if (file.size / maxSize > 1) {
        this.uploadError = `File size must be less than ${this.maxMB}MB`;
        this.error = true;
				return;
			}
      const reader = new FileReader();
      reader.onload = loadEvent => {
        this.url = loadEvent.target.result;
        this.$emit('input',this.url);
        this.$emit('change',this.url);
      }
      reader.onError = () => {
        this.uploadError = 'Error reading file';
        this.error = true;
      }
      reader.readAsDataURL(file);
      this.$refs.fileInput.type='text';   // Required to allow uploading same file
      this.$refs.fileInput.type='file';
    },
    clear() {
      this.url = '';
      this.$emit('input',this.url);
      this.$emit('change',this.url);
      this.$emit('delete');
    }
  }
}
</script>